import Chip from '@components/Chip/Chip';
import { ReportSummary } from '@components/ReportList/reportList.types';
import { useAppTranslation } from '@hooks/useAppTranslation';
import { Card, H4, SizableText, Text, YStack } from 'tamagui';

interface ReportCardProps {
  report: ReportSummary;
  backgroundColor?: string;
  padded?: boolean;
  onPress?: () => void;
}
export default function ReportCard({
  report,
  onPress,
  backgroundColor = '$tertiary75',
  padded = true,
}: ReportCardProps): React.ReactNode {
  const { t } = useAppTranslation();
  const reportCountry = report.countryName ?? report.countryCode;

  return (
    <Card
      padded={padded}
      gap="$3"
      onPress={onPress}
      cursor={onPress ? 'pointer' : undefined}
      pressStyle={onPress ? { opacity: 0.8 } : undefined}
    >
      <Card.Header
        padding={0}
        flexDirection="row"
        justifyContent="space-between"
      >
        <H4>{report.code}</H4>
        <Chip text={report.status.text} color={report.status.color} />
      </Card.Header>
      <YStack zIndex={10}>
        <SizableText fontFamily="$bold" color="$secondary">
          {report.etiologicalAgent}
        </SizableText>
        <Text color="$secondary75">{report.etiologyType}</Text>
      </YStack>
      <Card.Footer>
        <YStack gap="$1">
          <Text>
            {report.specie}
            {report.individualsAffected
              ? ` - ${report.individualsAffected} ${t('reports.individuals')}`
              : ''}
          </Text>
          <Text>
            {report.detectionDate}
            {reportCountry ? ` • ${reportCountry}` : ''}
          </Text>
        </YStack>
      </Card.Footer>

      <Card.Background backgroundColor={backgroundColor}></Card.Background>
    </Card>
  );
}
